import { IDataState } from "@/store/modules/data/index";
import { ActionTree, GetterTree } from "vuex";
import { IState } from "@/store";
import { DataModules } from "@/store/modules/data";
import { ApiPathGetter } from "@/models/api";
import { Methods } from "@/models/methods";
import { AxiosResponse } from "axios";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (s, g, rS, { isAdminContext }): ApiPathGetter => () => {
    const admin = "api/admin/modules/web_hosting/domains";
    const client = "api/modules/web_hosting/domains";
    const contextual = isAdminContext ? admin : client;
    return { client, admin, contextual };
  }
};

const actions: ActionTree<IDataState, IState> = {
  getDacAvailability: async ({ dispatch, getters }, payload) => {
    const response: AxiosResponse = await dispatch(
      "api/call",
      {
        method: Methods.GET,
        path: `${getters.apiPath().contextual}/search/status`,
        requestConfig: payload
      },
      { root: true }
    );
    return !!response?.data?.available;
  },
  getClientDomains: async ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/get",
      {
        ...payload,
        path: `${getters.apiPath().contextual}/client_domains`,
        storeModule: DataModules.HOST_MODULE
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  modules: {
    tlds: require("./tlds").default
  }
};
